module.exports = __webpack_public_path__ + "static/media/prommoto-long.ec476393.svg";